import { render, staticRenderFns } from "./EdicaoInternacao.vue?vue&type=template&id=d065ef1e&scoped=true&"
import script from "./EdicaoInternacao.vue?vue&type=script&lang=js&"
export * from "./EdicaoInternacao.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoInternacao.vue?vue&type=style&index=0&id=d065ef1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065ef1e",
  null
  
)

export default component.exports